module.exports = __webpack_public_path__ + "static/img/20211211_2.7b29707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211211_2.png
// module id = iG02
// module chunks = 0